const CDN = "https://customer-assets-jt897jd0.emergentagent.net/job_gym-makeover-ai/artifacts";

export const IMAGES = {
  // Trenerka — zdjęcie na górze (hero)
  trainerTop: `${CDN}/7gth7pt6_Projekt%20bez%20nazwy%20%281%29.png`,

  // Prawdziwe metamorfozy podopiecznych (kg wtopione w grafikę)
  t1: `${CDN}/gfw1h04p_image_DAD15AA4-35B2-45A4-A2E6-B9454867174B_1778965754.png`,
  t2: `${CDN}/hl1wcy85_image_B5A4CA4F-0482-4BD3-A9D5-FCEC0F89843A_1778965754.png`,
  t3: `${CDN}/fplc530b_image_B1DBBBF6-2847-46E6-ADC6-54F3EE226D5A_1778965754.png`,
  t4: `${CDN}/iuwek5bl_image_203FA190-ACD5-4A90-8A29-40F509621434_1778965754.png`,
  t5: `${CDN}/t2besfar_Judyta.png`,
  t6: `${CDN}/sfymoivb_image_467BA14A-91CC-4654-88EC-3E666FFBB35D_1769005562.jpeg`,
  t7: `${CDN}/fo7qg994_image_033F63AE-F458-4E46-BE12-8CDE7A53B9EE_1778965754.png`,
  t8: `${CDN}/3n3epx66_image.png`,

  // Uzupełniające zdjęcia stockowe (tło, mapa, atmosfera)
  heroBg:
    "https://images.unsplash.com/photo-1550345332-09e3ac987658?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx3b21hbiUyMGd5bSUyMHRyYWluaW5nJTIwY29uZmlkZW50fGVufDB8fHx8MTc4NjM5NTQ0OHww&ixlib=rb-4.1.0&q=85",
  manifesto:
    "https://images.unsplash.com/photo-1548690312-e3b507d8c110?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGd5bSUyMHRyYWluaW5nJTIwY29uZmlkZW50fGVufDB8fHx8MTc4NjM5NTQ0OHww&ixlib=rb-4.1.0&q=85",
  gym:
    "https://images.unsplash.com/photo-1674834727206-4bc272bfd8da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBneW0lMjBpbnRlcmlvciUyMGVxdWlwbWVudHxlbnwwfHx8fDE3ODYzOTU0NDh8MA&ixlib=rb-4.1.0&q=85",
};
